export const ReleaseSeverity = {
    Minor: 0,
    Major: 1,
} as const;

export type ReleaseSeverity = (typeof ReleaseSeverity)[keyof typeof ReleaseSeverity];
